






























































import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class AppInput extends Vue {
  @Prop() label: string;
  @Prop() name: string;
  @Prop() placeholder: string;
  @Prop({ default: "text" }) type: string;
  @Prop() disabled: boolean;
  @Prop({ default: true }) editable: boolean;
  @Prop() value: string;
  @Prop() error: string;
  defaultClass: string =
    "appearance-none w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline";
  labelClass: string = "block text-gray-600 text-xs font-bold px-3";
  @Emit("input")
  update(e: any) {
    const input: any = this.$refs.input;
    return input.value;
  }

  @Emit("onEditable")
  onEditable() {}
}
